import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsModule } from 'ngx-bootstrap/tabs';
// Service
import { SharedService } from 'src/app/shared/services/shared.service';
import { getFeatureVisibility } from 'src/app/shared/functions';
import { AccountManagementComponent } from '../account-management/account-management.component';
import { UserManagementComponent } from '../user-management/user-management.component';
import { PaymentComponent } from '../payment/payment.component';
import { DistributorManagementComponent } from '../distributor-management/distributor-management.component';
import { AccountingOptionsComponent } from '../accounting-options/accounting-options.component';
import { AccountChangeLogComponent } from '../account-change-log/account-change-log.component';
import { Form3310AutofillComponent } from '../form-3310-autofill/form-3310-autofill.component';
import { EmailConfigComponent } from '../email-config/email-config.component';

@Component({
    selector: 'app-account-dashboard',
    templateUrl: './account-dashboard.component.html',
    styleUrl: './account-dashboard.component.scss',
    standalone: true,
    imports: [TabsModule, AccountManagementComponent, UserManagementComponent, PaymentComponent, DistributorManagementComponent, AccountingOptionsComponent, AccountChangeLogComponent, Form3310AutofillComponent, EmailConfigComponent]
})
export class AccountDashboardComponent implements OnInit {

  public getFeatureVisibility = getFeatureVisibility;
  activeTabId: string = 'tab1';

  constructor(
    public sharedService: SharedService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    const tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab) {
      this.activeTabId = tab;
    }
  }

}
